import { useGetWorkTemplateCreateData } from 'ogp/hooks/queryHooks/jobs/use-get-work-template-create-data';
import { RenderUnsettledUI } from 'shared/components';
import { useGetCompanyEmploymentTypes } from 'api';
import { useSiteDetection } from 'shared/hooks';
import { useGetWorkTemplateDefaults } from 'ogp/hooks/queryHooks/jobs/use-get-work-template-defaults';
import { WorkTemplateCreatePage } from './work-template-create-page';
import { workTemplateAlerts } from '../../../../../../../shared/components/alerts';

export const WorkTemplateCreateDataProvider = () => {
  const workTemplateCreateDataQuery = useGetWorkTemplateCreateData();
  const workTemplateDefaultsQuery = useGetWorkTemplateDefaults();

  const { site } = useSiteDetection();
  const employmentTypeOfCompanyQuery = useGetCompanyEmploymentTypes(site);

  if (employmentTypeOfCompanyQuery.status !== 'success') {
    return <RenderUnsettledUI data={employmentTypeOfCompanyQuery} />;
  }

  if (workTemplateCreateDataQuery.status !== 'success') {
    return <RenderUnsettledUI data={workTemplateCreateDataQuery} />;
  }

  if (workTemplateDefaultsQuery.status !== 'success') {
    return <RenderUnsettledUI data={workTemplateDefaultsQuery} />;
  }

  return (
    <WorkTemplateCreatePage
      defaultValues={workTemplateDefaultsQuery.data}
      workTemplateCreateData={workTemplateCreateDataQuery.data}
      pageTitle={'Nieuwe functie aanmaken'}
      successMessage={workTemplateAlerts.success.created}
      employmentType={employmentTypeOfCompanyQuery.data}
    />
  );
};
